import File from './File.js';
export default File;
//# sourceMappingURL=index.js.map